<script>
  import { I18n } from "i18n-js"
  import i18n_translations from "../../../javascript/locales.json"
  import News from "../../components/_news.svelte"

  let { RailsApp, landing_page } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale
</script>

<section id="hero" class="mb-3 container">
  {#if landing_page === 'home'}
    <div class="fs-4 mb-3">
      {i18n.t('Translations.Index.sections.hero.home.title')}
    </div>
    <News {RailsApp} />
  {:else if landing_page === 'word'}
    <div class="fs-4 mb-1">
      {i18n.t('Translations.Index.sections.hero.word.title')}
    </div>
    <p class="text-muted mb-3">
      {i18n.t('Translations.Index.sections.hero.word.description')}
    </p>
  {:else if landing_page === 'excel'}
    <div class="fs-4 mb-1">
      {i18n.t('Translations.Index.sections.hero.excel.title')}
    </div>
    
    <p class="text-muted mb-3">
      {i18n.t('Translations.Index.sections.hero.excel.description')}
    </p>
  {:else if landing_page === 'powerpoint'}
    <div class="fs-4 mb-1">
      {i18n.t('Translations.Index.sections.hero.powerpoint.title')}
    </div>
    <p class="text-muted mb-3">
      {i18n.t('Translations.Index.sections.hero.powerpoint.description')}
    </p>
  {:else if landing_page === 'keynote'}
    <div class="fs-4 mb-1">
      {i18n.t('Translations.Index.sections.hero.keynote.title')}
    </div>
    <p class="text-muted mb-3">
      {i18n.t('Translations.Index.sections.hero.keynote.description')}
    </p>
  {/if}
</section>
